const FlexColumn = ({ children }) => (
    <div style={{ background: 'var(--input-border-c)', display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
        {children}
    </div>
)

export default FlexColumn